import { render, staticRenderFns } from "./SliderCertificates.vue?vue&type=template&id=01e56f5a"
import script from "./SliderCertificates.vue?vue&type=script&lang=js"
export * from "./SliderCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports